import { Component, input, output } from '@angular/core';

import { Product, ProductShippingStatus } from '@services/products/interfaces/product.interfaces';
import { ClpCurrencyPipe } from '@shared/pipes/clp-currency.pipe';

import { CDN_PRODUCTS_URL } from '@constants/constants';

@Component({
  selector: '[app-product-table-row]',
  standalone: true,
  imports: [
    ClpCurrencyPipe,
  ],
  templateUrl: './product-table-row.component.html',
  styleUrls: ['./product-table-row.component.css'],
})

export class ProductTableRowComponent {
  public product = input.required<Product>();
  public edit = output<Product>();

  public get productImage(): string {
    const imageUrl = this.product().imageUrl ?? '';

    return /^https?:\/\//i.test(imageUrl) ? imageUrl : `${CDN_PRODUCTS_URL}${imageUrl}`;
  }

  public get publicUrl(): string {
    const slug = this.product()?.slug;
    return slug ? `/catalogo/${slug}` : '#';
  }

  public get shippingStatus(): ProductShippingStatus {
    return this.product().shipping?.status ?? 'missing';
  }

  public get shippingDimensionsText(): string {
    const dimensions = this.product().shipping?.dimensions;
    return dimensions
      ? `${dimensions.lengthCm}×${dimensions.widthCm}×${dimensions.heightCm} cm · ${dimensions.weightGrams} g`
      : '';
  }

  public get isViewDisabled(): boolean {
    const product = this.product();
    return !product.slug || product.status === 'inactive';
  }
}
